export const CatalogActionTypes = {
  REFRESH_CATALOG: "REFRESH_CATALOG",
  REFRESH_CATALOG_SUCCESS: "REFRESH_CATALOG_SUCCESS",
  REFRESH_CATALOG_LESSON: "REFRESH_CATALOG_LESSON",
  REFRESH_CATALOG_LESSON_SUCCESS: "REFRESH_CATALOG_LESSON_SUCCESS",
  REFRESH_CATALOG_LESSON_FAILURE: "REFRESH_CATALOG_LESSON_FAILURE",
};
